import React from "react";
import { RCCGrid, RCCInput } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import DateTimePicker from "../DateTimePicker";
import FiltersContainer from "../FiltersContainer";
import Select from "../Select";
import { ISidebarCardFilters } from "./interface";

const SidebarCardFilters: React.FC<ISidebarCardFilters> = ({
	control,
	filtersFunction,
	handleSubmit,
	register,
	reset,
	filters,
	showFilters
}) => {
	const { translate } = useTranslation();

	if(!showFilters)
		return null;
        

	return(
		<FiltersContainer
			onSubmitFilters={handleSubmit(filtersFunction)}
			resetFilters={() => reset({ f: "", startDate: null, endDate: null, active: "S" })}
		>
			<RCCGrid
				container
				item
			>
				<RCCGrid
					container 
					item
					xs={12}
				>
					<DateTimePicker 
						label={translate("Data Inicial")}
						name="startDate"
						type="datePicker"
						control={control}
						defaultValue={filters.startDate}
					/>
				</RCCGrid>
				<RCCGrid
					container 
					item
					xs={12}
				>
					<DateTimePicker 
						label={translate("Data Final")}
						name="endDate"
						type="datePicker"
						control={control}
						defaultValue={filters.endDate}
					/>
				</RCCGrid>
				<RCCGrid
					container 
					item
					xs={12}
				>
					<Select 
						control={control}
						name="active" 
						options={[
							{value: "S", label: translate("Sim")}, 
							{value: "N", label: translate("Não")},
							{value: "T", label: translate("Todos")}
						]} 
						label={translate("Ativo")}
						defaultValue={filters.active}
						submit="value"
					/>
				</RCCGrid>
				<RCCGrid
					container 
					item
					xs={12}
					styleInline="margin-bottom: 30px !important"
				>
					<RCCInput
						name="f" label={translate("Pesquisar")}
						register={register}
						defaultValue={filters.f}
					/>
				</RCCGrid>
			</RCCGrid>
		</FiltersContainer>
	);};

export default SidebarCardFilters;
